import { render, staticRenderFns } from "./Movements.vue?vue&type=template&id=4b336178&scoped=true&lang=pug"
import script from "./Movements.vue?vue&type=script&lang=js"
export * from "./Movements.vue?vue&type=script&lang=js"
import style0 from "./Movements.vue?vue&type=style&index=0&id=4b336178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b336178",
  null
  
)

export default component.exports